import * as React from 'react';
import { flow, map, isEmpty } from 'lodash';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Col, Modal, Button, FormGroup, Form, Alert, Row } from 'react-bootstrap';
import { IChannel, ITraveller } from '../../../../../../data/api/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../util/validators';
import FaSpinner from 'react-icons/fa/spinner';
import { IAuthState } from '../../../../../../services/auth/models';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../../../services/quote/models';
import { IStore } from '../../../../../../redux/IStore';
import { Link, withRouter } from 'react-router-dom';
import FaPencil from 'react-icons/fa/pencil';

interface ISaveQuoteFormProps {
  travellers: ITraveller[];
  auth: IAuthState;
  quote: IQuoteState;
  password: string;
  passwordConfirmation: string;
  onGoToMyAccount: any;
  onCloseModal: any;
  onEditDetails: any;
  handleSubmit: any;
  quoteErrors: any;
  dispatch: any;
  change: any;
  isQuoteSaved: boolean;
  channel: IChannel;
}

interface ISaveQuoteFormState {
  openModal: boolean;
}

class SaveQuoteForm extends React.Component<ISaveQuoteFormProps, ISaveQuoteFormState> {
  public componentWillMount() {
    const { dispatch, change, quote } = this.props;

    change('title', quote.application.travellers[0].title);
    change('firstName', quote.application.travellers[0].firstName);
    change('lastName', quote.application.travellers[0].lastName);
    change('email', quote.application.travellers[0].email);
    change('dob', quote.application.travellers[0].dob);
  }

  private renderErrors = (errors) => {
    if (isEmpty(errors)) {
      return;
    }
    return (
      <Alert>
        {map(errors, (error, key) => {
          return (
            <p key={key}>{error.detail}</p>
          );
        })}
      </Alert>
    );
  }
  public render() {
    const {
      quote,
      handleSubmit,
      onGoToMyAccount,
      onEditDetails,
      onCloseModal,
      password,
      passwordConfirmation,
      isQuoteSaved,
      channel,
      quoteErrors,
    } = this.props;
    const customer = quote.customer;
    const customerStatus = customer.length > 0 && customer[0].status;
    const quoteReference = quote.application.quoteReference;
    const disableSaveQuote =
      customerStatus === 'new' &&
      !password &&
      !passwordConfirmation &&
      password !== passwordConfirmation;
    const NOT_APPLICABLE = 'not applicable';

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <Modal.Body>
          {this.renderErrors(quoteErrors)}
          {!isQuoteSaved ? (
            <div>
              {customerStatus === NOT_APPLICABLE && (
                <div>
                  <p>To save your quote please confirm the details below are correct and enter a password.</p>
                  <FormGroup controlId="name">
                    <Col sm={2} >
                      Title
                      <Field
                        name="title"
                        type="text"
                        readOnly={true}
                        component={FieldFormControl}
                      />
                    </Col>
                    <Col sm={4} >
                      Forename
                      <Field
                        name="firstName"
                        type="text"
                        className="capitalize"
                        readOnly={true}
                        component={FieldFormControl}
                      />
                    </Col>
                    <Col sm={6} >
                      Surname
                      <Row>
                        <Col xs={9}>
                          <Field
                            name="lastName"
                            type="text"
                            className="capitalize"
                            readOnly={true}
                            component={FieldFormControl}
                          />
                        </Col>
                        <Col xs={3}>
                          <a onClick={onEditDetails} className="edit-dob">
                            <FaPencil />
                          </a>
                        </Col>
                      </Row>
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="email">
                    <Col sm={12}  className="margin-top" >
                      Email Address
                      <Row>
                        <Col xs={9}>
                          <Field
                            name="email"
                            className="lowercase"
                            type="text"
                            readOnly={true}
                            component={FieldFormControl}
                          />
                        </Col>
                        <Col xs={3}>
                          <Link to="/" className="edit-dob">
                            <FaPencil />
                          </Link>
                        </Col>
                      </Row>
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="dob">
                    <Col sm={6}  className="margin-top">
                      Date of Birth
                      <Row>
                        <Col xs={9}>
                          <Field
                            name="dob"
                            type="text"
                            readOnly={true}
                            component={FieldFormControl}
                          />
                        </Col>
                        <Col xs={3}>
                          <Link to="/" className="edit-dob">
                            <FaPencil />
                          </Link>
                        </Col>
                      </Row>
                    </Col>
                  </FormGroup>
                  <p className="margin-top">
                    Please create an account by setting a password below so you
                    can access these documents later. Password must be
                    8 characters long, with at least one lowercase letter, one
                    uppercase letter, one special character and one digit.
                  </p>
                  <FormGroup>
                    <Col sm={12} className="">
                      <div className="manual-field-label">
                        <strong>Password</strong>
                      </div>
                      <Field
                        name="password"
                        type="password"
                        placeholder="Password"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      />
                    </Col>
                    <Col sm={12} className="margin-top">
                      <div className="manual-field-label">
                        <strong>Password confirmation</strong>
                      </div>
                      <Field
                        name="passwordConfirmation"
                        type="password"
                        placeholder="Confirm Password"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      />
                    </Col>
                  </FormGroup>
                </div>
              )}
              {customerStatus === 'pending' ||
                (customerStatus === 'new' && (
                  <div>
                    <p>
                      We noticed that you already have an account with us,
                      thanks for coming back!
                    </p>
                    <p>Your quote has been saved under your account</p>
                    <h4>Reference: {quoteReference}</h4>
                    <p>
                      You can access your account at any time, to view your
                      quotes or documentation.
                    </p>
                  </div>
                ))}
              {customerStatus === 'active' &&
                !isQuoteSaved && (
                  <div>
                    <p>
                      To save your your quote to your account, please click save
                    </p>
                  </div>
                )}
            </div>
          ) : (
            <div>
              <p>Your quote has been saved under your account</p>
              <h3>Reference: {quoteReference}</h3>
              <p>
                You can access your account at any time, to view your
                documentation.
              </p>
              <p>
                If you have any queries about your quote, please call us on{' '}
                {channel.phone}.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isQuoteSaved ? (
            <div>
              <div>
                <Button
                  bsStyle="primary"
                  className="btn-remove-border"
                  type="submit"
                  disabled={disableSaveQuote || quote.isLoading}
                >
                  <span className="save-button">
                    {quote.isLoading && (
                      <FaSpinner className="fa fa-spin save-button--margin"/>
                    )}
                    Save your Quote
                  </span>

                </Button>
                <Button bsStyle="primary" className="pull-left btn-remove-border" onClick={onCloseModal}>
                  Resume your Quote
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <Button bsStyle="primary" onClick={onCloseModal}>
                Resume your Quote
              </Button>
              <Button bsStyle="primary" onClick={onGoToMyAccount}>
                Go to My Account
              </Button>
            </div>
          )}
        </Modal.Footer>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'Your confirmed password doesn\'t match the first field, please enter them again.';
  }
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'save_quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('save_quote');

    return component;
  },
  connect((state: IStore) => {
    const password = selector(state, 'password');
    const passwordConfirmation = selector(state, 'passwordConfirmation');

    return {
      password,
      passwordConfirmation,
      auth: state.auth,
      quote: state.quote,
      channel: state.branding.channel,
    };
  }),
])(SaveQuoteForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/SaveQuoteModal/components/SaveQuoteModalForm/index.tsx